import { render, staticRenderFns } from "./pannel-data.vue?vue&type=template&id=b5b37428&scoped=true&"
import script from "./pannel-data.vue?vue&type=script&lang=js&"
export * from "./pannel-data.vue?vue&type=script&lang=js&"
import style0 from "./pannel-data.vue?vue&type=style&index=0&id=b5b37428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b37428",
  null
  
)

export default component.exports